export const INITIAL_USER_REGION_ID = 36 // Воронежская область

export enum EUserRegionStorageCookieNames {
  REGION_ID = 'region_id',
  REGION_CONFIRMED = 'region_confirmed',
}
